<template>
	<div id="login">
    <!-- //? Refazer esta página com o Vuelidate. Está funcionando corretamente, mas pode ser aprimorada. -->
      <v-layout wrap class="pa-5">
        <v-flex md4 offset-md4>
          <span class="display-1">Login</span>
          <v-form v-model="valid" lazy-validation onsubmit="return false">
            <!-- //TODO: Converter "Rules" no Vuelidate -->
            <v-text-field label="E-mail" v-model="form.email" :rules="emailRules" flat required></v-text-field>
            <v-text-field :rules="passwordRules" label="Senha" v-model="form.password" type="password" flat required></v-text-field>

            <v-btn type="submit" :disabled="!valid" color="accent" @click="login()" class="mx-3">Fazer Login</v-btn>
          </v-form>
            <!-- //* Alerta de erros do firebase -->
            <v-alert class="ma-3 r-alert" :value="alert.show" :type="alert.type">{{alert.message}}</v-alert>
        </v-flex>
      </v-layout>
      
      
	</div>
</template>

<script>
// Firebase import
import { auth, db } from '../firebase'

export default {
    name: 'Login',

    data () {
        return {
          //var1: foo

          //* Variáveis do formulário
					name: '',
          form: {
            email: '',
            password: '',
            confirmPassword: '',
          },

          //* Regras para a validação de inputs
          valid: true,
          emailRules: [
            v => !!v || 'O e-mail é obrigatório!',
            v => /.+@.+/.test(v) || 'Este não é um e-mail válido.'
          ],
          passwordRules: [
            v => !!v || 'A senha é obrigatória!',
            v => v.length > 5 || 'A senha deve ter no mínimo 6 caracteres.'
          ],

          //* Configuração do alerta
          alert: {
            type: 'error',
            show: false,
            message: ''
          }
        }
    },
    methods: {
      login: function() {
        auth.signInWithEmailAndPassword(this.form.email, this.form.password).then(
          data => {
            // console.log('Logado com sucesso!')
          },
          function(err) {
            // Erro do firebase transformando em conteudo pro alerta
            // console.log(err)
            switch (err.code) {
              case 'auth/invalid-email':
                this.error = 'Email não cadastrado.'
                this.alert.type = 'warning',
                this.alert.show = true,
                this.alert.message = this.error
                break;
              case 'auth/user-disabled':
                this.error = 'Usuário desabilitado.'
                this.alert.type = 'error',
                this.alert.show = true,
                this.alert.message = this.error
                break;
              case 'auth/user-not-found':
                this.error = 'Usuário inexistente.'
                this.alert.type = 'warning',
                this.alert.show = true,
                this.alert.message = this.error
                break;
              case 'auth/wrong-password':
                this.error = 'Senha Incorreta.'
                this.alert.type = 'warning',
                this.alert.show = true,
                this.alert.message = this.error
                break;
              default:
                this.error = 'Não foi possível se conectar, tente novamente mais tarde.'
                this.alert.type = 'error',
                this.alert.show = true,
                this.alert.message = this.error
            }
          }.bind(this)
        )
      },
    }
}
</script>

<style lang="sass">
// *Style da Resultam

.r-alert 
  border-radius: 4px
  border-top: none
  

// *Alterações de Style do Vuetify

.card--flex-toolbar 
  margin-top: 16px
  
</style>